export enum PROVIDERS {
	HLSPLAYER = 'hlsplayer',
	YOUTUBE = 'youtube',
	OPENTOK = 'opentok',
	HTML5 = 'html5'
}
